<template>
    <div class="a-initial-loader initial-loader" :class="{'initial-loader--on-top': !modernizer.webgl || !(modernizer.webworkers && modernizer.webglextensions) }">
        <svg
            class="loader__shape"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="0 0 300 300"
            shape-rendering="geometricPrecision"
        >
            <path
                class="loader__clever"
                d="M214.8,95.5c0,0,61.7,49.7,0,107.9l-24-18.8l12,32.6c-56.5,54.8-106.2,0-106.2,0l12-29.1l-27.4,17.1
	            C28,140.1,82.8,93.8,82.8,93.8l27.4,17.1L93.1,81.8c0,0,49.7-61.7,113.1,0l-22.3,32.6L214.8,95.5z"
            />
        </svg>
        <span v-if="canStart" class="loader__text">
            {{ progress }} %
        </span>
        <span v-else class="loader__text loader__text--small">
            <div v-if="!modernizer.webgl || !modernizer.webglextensions">Oops.. WebGL is not available in your browser.<br/> Please contact your admin to troubleshoot.</div>
            <div v-if="!modernizer.webworkers"> Oops.. Web Workers are not available in your browser.<br/><br/> Please contact your admin to troubleshoot.</div>
        </span>
    </div>
</template>

<script>
import canStart from '../../../utils/mixins/can-start'
export default {
    name: 'AInitialLoader',
    mixins: [canStart],
    data(){
        return {
            progress: 0,
            progressInterval: null,
            modernizer: window.Modernizr,
        }
    },
    methods:{
        incrementProgress(){
            if(this.progress<100){
                this.progress+=1;
                this.modernizer = window.Modernizr
            }
        }

    },
    mounted() {
        this.progressInterval = setInterval(this.incrementProgress,50)
    },
    beforeDestroy() {
        clearInterval(this.progressInterval)
    }
}
</script>

<style lang="scss">
@import "a-initial-loader";
</style>